/* eslint-disable import/prefer-default-export */
export default 'https://vue-study.skillbox.cc';
// export default API_BASE_URL;
